import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalSingleInput } from '@/lib/v2/organisms';

import { useActionsRules } from '@/src/modules/AutomationModuleNew/hooks/Rules/useActionsRules';
import { useRulesValidations } from '@/src/modules/AutomationModuleNew/hooks/useRulesValidations';

type RenameRulesModalProps = {
  isOpen: boolean;
  onClose: () => void;
  id: number;
  name: string;
  refetchData: () => void;
};

const RenameRulesModal = ({ isOpen, onClose, id, refetchData, name }: RenameRulesModalProps) => {
  const { t } = useTranslation();
  const { VALIDATION_RULES } = useRulesValidations();
  const { isLoading, renameRule } = useActionsRules();

  const handleSubmitEdition = useCallback(
    async (name: string) => {
      const response = await renameRule(name, id);
      if (!response?.isValidInput) return response;
      onClose();
      refetchData();
    },
    [renameRule, id, onClose, refetchData]
  );

  return (
    <ModalSingleInput
      defaultValue={name}
      disabled={isLoading}
      disabledSubmitButton={isLoading}
      id="edit-rule-action-modal"
      isLoading={isLoading}
      isOpen={isOpen}
      rules={VALIDATION_RULES}
      title={t(`RenameRulesModal.titleModalEdit`)}
      onClose={onClose}
      onSubmit={handleSubmitEdition}
    />
  );
};

export default memo(RenameRulesModal);
